<template src="./app.html"></template>

<script>
import authEndpoints from './views/authorization/auth.endpoints.js';
import authMixin from './js/authMixin.js';
import signInPage from './views/authorization/signInPage/signInPage.vue';
import intermediariesPage from './views/intermediaries/intermediariesPage/intermediariesPage.vue';
import intermediariesEditModal from './views/intermediaries/intermediariesEditModal/intermediariesEditModal.vue';
import systemsPage from './views/systems/systemsPage/systemsPage.vue';
import systemsEditModal from './views/systems/systemsEditModal/systemsEditModal.vue';
import institutionsPage from './views/institutions/institutionsPage/institutionsPage.vue';
import institutionsPreliminaryModal from './views/institutions/institutionsPreliminaryModal/institutionsPreliminaryModal.vue';
import institutionsEditModal from './views/institutions/institutionsEditModal/institutionsEditModal.vue';
import usersPage from './views/users/usersPage/usersPage.vue';
import usersPreliminaryModal from './views/users/usersPreliminaryModal/usersPreliminaryModal.vue';
import usersEditModal from './views/users/usersEditModal/usersEditModal.vue';
import usersChangePasswordModal from './views/users/usersChangePasswordModal/usersChangePasswordModal.vue';
import surveysPage from './views/surveys/surveysPage/surveysPage.vue';
import surveysEditModal from './views/surveys/surveysEditModal/surveysEditModal.vue';
import surveyInfoPage from './views/surveys/surveyInfoPage/surveyInfoPage.vue';
import teamUserEditModal from './views/surveys/teamUserEditModal/teamUserEditModal.vue';
import teamUserImportModal from './views/surveys/teamUserImportModal/teamUserImportModal.vue';
import manageRemindersModal from './views/surveys/manageRemindersModal/manageRemindersModal.vue';
import remindersEditModal from './views/surveys/remindersEditModal/remindersEditModal.vue';
import customizeSurveyModal from './views/surveys/customizeSurveyModal/customizeSurveyModal.vue';

export default {
    name: 'app',
    mixins: [authMixin],
    components: {
        signInPage,
        intermediariesPage,
        intermediariesEditModal,
        systemsPage,
        systemsEditModal,
        institutionsPage,
        institutionsPreliminaryModal,
        institutionsEditModal,
        usersPage,
        usersPreliminaryModal,
        usersEditModal,
        usersChangePasswordModal,
        surveysPage,
        surveysEditModal,
        surveyInfoPage,
        teamUserEditModal,
        teamUserImportModal,
        manageRemindersModal,
        remindersEditModal,
        customizeSurveyModal
    },
    data() {
        return {
            isSidebarOpened: true,
            sidebarUserItems: [
                {
                    id: 'profile',
                    text: 'My Profile',
                    onClick: this.mnuMyProfileOnClick,
                    iconCss: 'fa fa-user app-sidebar-icon app-brand-color-primary',
                },
                {
                    text: 'Sign Out',
                    onClick: this.mnuSignOutOnClick,
                    iconCss: 'fa-solid fa-right-from-bracket app-sidebar-icon app-brand-color-primary',
                },
            ],
        };
    },
    computed: {
        modalsOpened() {
            return this.$store.getters['ModalModule/ModalsOpened'];
        },
        isSidebarVisible() {
            if (this.activeRoute === 'signIn') {
                return false;
            }

            return true;
        },
        sidebarMenuItems() {
            let items = [];
            let isSuperAdmin = this.$store.state.PermissionsModule.isSuperAdmin;

            if (isSuperAdmin || this.$store.state.PermissionsModule.intermediaryPermissions.CanUpdate) {
                items.push({
                    id: 'intermediaries',
                    text: 'Intermediaries',
                    onClick: this.mnuIntermediariesOnClick,
                    iconCss: 'fa-solid fa-people-arrows app-sidebar-icon app-brand-color-primary',
                });
            }

            if (isSuperAdmin || this.$store.state.PermissionsModule.systemPermissions.CanUpdate) {
                items.push({
                    id: 'systems',
                    text: 'Systems',
                    onClick: this.mnuSystemsOnClick,
                    iconCss: 'fa-solid fa-cubes-stacked app-sidebar-icon app-brand-color-primary',
                });
            }

            if (isSuperAdmin || this.$store.state.PermissionsModule.institutionPermissions.CanUpdate) {
                items.push({
                    id: 'institutions',
                    text: 'Institutions',
                    onClick: this.mnuInstitutionsOnClick,
                    iconCss: 'fa fa-university app-sidebar-icon app-brand-color-primary',
                });
            }

            if (isSuperAdmin || this.$store.state.PermissionsModule.userPermissions.CanUpdate) {
                items.push({
                    id: 'users',
                    text: 'Users',
                    onClick: this.mnuDashboardsUsersOnClick,
                    iconCss: 'fa fa-user-group app-sidebar-icon app-brand-color-primary',
                });
            }
            
            if (isSuperAdmin || this.$store.state.PermissionsModule.surveyPermissions.CanUpdate) {
                items.push({
                        id: 'surveys',
                        text: 'Surveys',
                        onClick: this.mnuSurveysOnClick,
                        iconCss: 'fa-solid fa-clipboard-question app-sidebar-icon app-brand-color-primary',
                    });
            }

            items.push({
                    id: 'results',
                    text: 'Results',
                    onClick: this.mnuResultsOnClick,
                    iconCss: 'fa fa-pie-chart app-sidebar-icon app-brand-color-primary',
                });

            return items;
        }
    },
    methods: {
        toggleClick() {
            this.isSidebarOpened = !this.isSidebarOpened;
            this.$refs.sidebarInstance.toggle();
        },
        mnuOnClick(args) {
            if (args.item.onClick) {
                args.item.onClick();
                this.setActiveItem();
            }
        },
        mnuIntermediariesOnClick() {
            this.$router.push({ name: 'intermediaries' });
        },
        mnuSystemsOnClick() {
            this.$router.push({ name: 'systems' });
        },
        mnuInstitutionsOnClick() {
            this.$router.push({ name: 'institutions' });
        },
        mnuDashboardsUsersOnClick() {
            this.$router.push({ name: 'users' });
        },
        mnuSurveysOnClick() {
            this.$router.push({ name: 'surveys' });
        },
        mnuResultsOnClick() {
            this.routeToDashboards(true);
        },
        mnuMyProfileOnClick() {
            this.$router.push({ name: 'profile' });
        },
        mnuSignOutOnClick() {
            this.isSidebarOpened = true;
            authEndpoints.signOut().then(() => {
                this.$store.commit('PermissionsModule/clearPermissions');
                this.$store.commit('clearStore');
                this.$store.commit('PermissionsModule/setSignedInUser', null);
                DMUtils.setCookie('ita-token', '', '/', window.cookieDomain, new Date(0).toUTCString());
                this.$router.push({ name: 'signIn' });
            });
        },
    },
    created() {
        let query = this.$route.query;

        if (query.refresh) {
            DMUtils.clearAuthToken();
        }

        if (query.confirm && query.email) {
            let confirm = this.$route.query.confirm || null;
            let email = this.$route.query.email || null;
            
            this.$router.push({ name: 'signIn', query: { confirm, email } })
            return;
        }

        let authToken = DMUtils.getAuthToken();

        if (authToken) {
             authEndpoints
                .signInWithAuthToken(authToken)
                    .then((response) => {
                        this.checkAndRouteUser(response);
                    });
        } else {
            DMUtils.setCookie('ita-token', '', '/', window.cookieDomain, new Date(0).toUTCString());
            this.$router.push({ name: 'signIn' });
        }
    },
};
</script>

<style>
@import '../../node_modules/@syncfusion/ej2-icons/styles/bootstrap.css';
@import '../../node_modules/@syncfusion/ej2-base/styles/bootstrap.css';
@import '../../node_modules/@syncfusion/ej2-vue-buttons/styles/bootstrap.css';
@import '../../node_modules/@syncfusion/ej2-vue-navigations/styles/bootstrap.css';
@import '../../node_modules/@syncfusion/ej2-vue-grids/styles/bootstrap.css';
@import '../../node_modules/@syncfusion/ej2-vue-popups/styles/bootstrap.css';
@import '../../node_modules/@syncfusion/ej2-vue-inputs/styles/bootstrap.css';
@import '../../node_modules/@syncfusion/ej2-vue-calendars/styles/bootstrap.css';
@import '../../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap.css';
@import '../../node_modules/@syncfusion/ej2-vue-dropdowns/styles/bootstrap.css';
@import '../../node_modules/@syncfusion/ej2-lists/styles/bootstrap.css';
@import '../../node_modules/@syncfusion/ej2-vue-richtexteditor/styles/bootstrap.css';
@import "../../node_modules/@syncfusion/ej2-vue-lists/styles/bootstrap.css";
</style>
